import React from "react";
import { Fab, Tooltip } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const WhatsappButton = () => {
  const handleClick = () => {
    window.open("https://wa.me/5541998712668", "_blank");
  };

  return (
    <Tooltip title="Como podemos ajudar?" placement="left">
      <Fab
        aria-label="contact-whatsapp"
        onClick={handleClick}
        sx={{
          position: "fixed",
          bottom: 20,
          right: 20,
          zIndex: 9999,
          backgroundColor: "#25D366",
          "&:hover": {
            backgroundColor: "#1EBE5D",
          },
        }}
      >
        <WhatsAppIcon fontSize={"large"} sx={{ color: "white" }} />
      </Fab>
    </Tooltip>
  );
};

export default WhatsappButton;
